import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BulbOutlined, SaveOutlined } from "@ant-design/icons";
import { Switch, Button, Spin } from "antd";

// Local imports
// redux
// selector
// actions
// utils
// hook
import PreviewPlayback from "./component/preview_playback";
import CardDraftMerge from "component/cards/draft/card_draft_merge";
import PreviewSpeakers from "./component/preview_speakers";
import { useActionDraftMergeSave } from "hook/draft/dialog/useActionDraftMerge";
import { useSelector } from "react-redux";
import { draftDialogMergeSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
// str

const DetailPreview = () => {
  // -------------------------- VAR -----------------------------
  const { loading, showModalConfirm } = useActionDraftMergeSave();
  const [searchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";
  // -------------------------- STATE ---------------------------
  const [highlight, setHighlight] = useState(true);

  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftDialogMergeSelector);
  // -------------------------- FUNCTION ------------------------
  const filter = data?.filter((f) => !f?.remove);
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderHeader = () => {
    return (
      <header className="sticky top-0 z-20 flex h-16 shrink-0 items-center justify-between border-b border-gray-200 bg-white px-6">
        <div className="flex items-center gap-4">
          <Button
            onClick={showModalConfirm}
            type="default"
            loading={loading}
            icon={<SaveOutlined />}
          >
            Lưu toàn bộ
          </Button>
        </div>
        <div className="flex items-center gap-4">
          {renderSpeaker()}
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <BulbOutlined className="text-yellow-500" />
            <span className="hidden sm:inline">Highlight</span>
          </div>
          <div className="flex items-center gap-2">
            <Switch size="small" checked={highlight} onChange={setHighlight} />
          </div>
        </div>
      </header>
    );
  };

  const renderTranscriptItem = (item, index) => {
    return (
      <div key={index}>
        <CardDraftMerge highlight={highlight} data={item} index={index} />
      </div>
    );
  };

  const renderSpeaker = () => {
    return (
      <div className="min-h-[40px] p-1">
        <PreviewSpeakers />
      </div>
    );
  };

  const renderPlaybackControls = () => {
    return <PreviewPlayback />;
  };

  const renderLists = () => {
    if (!filter) return null;
    return (
      <div className="mx-auto min-h-full max-w-4xl border-x border-gray-200 bg-white px-6 py-8 sm:px-10">
        {filter?.map((item, index) => renderTranscriptItem(item, index))}
      </div>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (tab !== "merged") return null;

  return (
    <div className="flex h-full w-full flex-col overflow-hidden bg-white">
      {renderHeader()}
      <Spin spinning={loading} tip="Đang xử lý lưu trữ...">
        <main className="relative flex-1 scroll-smooth bg-slate-50 pb-32">
          {renderLists()}
        </main>
      </Spin>
      {renderPlaybackControls()}
    </div>
  );
};
export default DetailPreview;
